var _rect, _rect2, _rect3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMenuIcon = function SvgMenuIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.19678,
    y: 19.1089,
    width: 20.0248,
    height: 1.89123,
    rx: 0.945615,
    fill: "#404249"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.19678,
    y: 4.20117,
    width: 20.0248,
    height: 1.89123,
    rx: 0.945615,
    fill: "#404249"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.19678,
    y: 11.6548,
    width: 14.4623,
    height: 1.89123,
    rx: 0.945615,
    fill: "#404249"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MenuIcon.8a10647b.svg";
export { ForwardRef as ReactComponent };